import { Grid as MaterialGrid } from "@material-ui/core";
import { FunctionComponent, useContext, useEffect } from "react";
import { Some } from "space-monad";
import styled from "styled-components";
import { hiddenDesktop, hiddenMobile } from "../../../components/layout";
import { CustomTabs } from "../../../components/tabs";
import { StakeContext } from "./context";
import AllClaimedRewards from "./tiles/all-claimed-rewards";
import AllStakedAmount from "./tiles/all-staked-amount";
import ClaimRewardsTile from "./tiles/claim";
import GetSkrtTile from "./tiles/get-skrt";
import PriceTile from "./tiles/price";
import Rewards from "./tiles/rewards-chart";
import { SecondaryTileWrapper } from "./tiles/secondary-tile";
import StakeTile from "./tiles/stake";
import StakedChart from "./tiles/staked-chart";
import StakersAmountTile from "./tiles/stakers-amount";
import Stats from "./tiles/stats";
import StatusTile from "./tiles/status";
import UnstakeTile from "./tiles/unstake";

interface IStakingPageProps {
  address: string;
}

const MobileGrid = styled(MaterialGrid).attrs({ container: true, spacing: 0 })`
  ${hiddenDesktop}
`;

const MobileItem = styled(MaterialGrid).attrs({ item: true, xs: 12 })`
  padding: 0.5em;
`;

const DesktopGrid = styled(MaterialGrid).attrs({ container: true, spacing: 3 })`
  ${hiddenMobile}
`;

const StakingPage: FunctionComponent<IStakingPageProps> = ({ address }) => {
  const { setStakingContractId } = useContext(StakeContext);

  useEffect(() => {
    setStakingContractId(Some(address));
  }, [address]);

  return (
    <>
      <DesktopGrid>
        <MaterialGrid item xs={12} md={8}>
          <MaterialGrid container spacing={3}>
            <MaterialGrid item xs={12}>
              <SecondaryTileWrapper alignment="left">
                <PriceTile />
                <AllClaimedRewards />
                <StakersAmountTile />
              </SecondaryTileWrapper>
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <StakedChart />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <GetSkrtTile />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <Stats />
            </MaterialGrid>
          </MaterialGrid>
        </MaterialGrid>

        <MaterialGrid item xs={12} md={4}>
          <MaterialGrid container spacing={3}>
            <MaterialGrid item xs={12}>
              <SecondaryTileWrapper alignment="right">
                <AllStakedAmount />
                <StatusTile />
              </SecondaryTileWrapper>
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <CustomTabs
                tabs={[
                  ...(process.env.REACT_APP_ENABLE_REWARDS_PROGRAM === 'true' ? [
                    {
                      title: "Lock SKRT",
                      content: <StakeTile />,
                    }] : []),
                  {
                    title: "Unlock Rewards",
                    content: <UnstakeTile />,
                  },
                ]}
              />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <ClaimRewardsTile />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <Rewards />
            </MaterialGrid>
          </MaterialGrid>
        </MaterialGrid>
      </DesktopGrid>

      <MobileGrid>
        <MobileItem>
          <SecondaryTileWrapper alignment="left">
            <PriceTile />
            <AllClaimedRewards />
            <StakersAmountTile />
          </SecondaryTileWrapper>
        </MobileItem>
        <MobileItem>
          <SecondaryTileWrapper alignment="right">
            <AllStakedAmount />
            <StatusTile />
          </SecondaryTileWrapper>
        </MobileItem>
        <MobileItem>
          <CustomTabs
            tabs={[
              ...(process.env.REACT_APP_ENABLE_REWARDS_PROGRAM === 'true' ? [
                {
                  title: "Lock SKRT",
                  content: <StakeTile />,
                }] : []),
              {
                title: "Unlock Rewards",
                content: <UnstakeTile />,
              },
            ]}
          />
        </MobileItem>
        <MobileItem>
          <ClaimRewardsTile />
        </MobileItem>
        <MobileItem>
          <Rewards />
        </MobileItem>
        <MobileItem>
          <StakedChart />
        </MobileItem>
        <MobileItem>
          <GetSkrtTile />
        </MobileItem>
        <MobileItem>
          <Stats />
        </MobileItem>
      </MobileGrid>
    </>
  );
};

export default StakingPage;
